import axios from 'axios';

export const GetRosters = () => {
  return axios.get(process.env.REACT_APP_API_GLOBAL_URL + `shift`);
};
export const AddRoster = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `shift/add`, obj, {
    headers,
  });
};
export const ShiftElementUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `shift/update`, obj, {
    headers,
  });
};
export const ShiftElementDelete = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(process.env.REACT_APP_API_GLOBAL_URL + `shift/delete`, obj, {
    headers,
  });
};
export default class Roster {}
